import { Button, Divider, Drawer, Stack } from '@mui/material';
import { Logo } from '@src/components/logo';
import { Text } from '@src/components/mui';
import { useTheme } from '@src/themes';
import { FC } from 'react';

interface AndroidInstallDrawerProps {
  open: boolean;
  onClose: () => void;
  onInstall: () => Promise<void>;
}

/**
 * Convite de instalação no Android, onde o navegador faz o trabalho.
 *
 * O botão apenas devolve a palavra ao diálogo nativo do navegador; a decisão
 * acontece lá, e por isso o drawer fecha logo em seguida, com ou sem aceite.
 */
const AndroidInstallDrawer: FC<AndroidInstallDrawerProps> = ({ open, onClose, onInstall }) => {
  const { COLORS } = useTheme();

  const handleInstall = async () => {
    await onInstall();
    onClose();
  };

  return (
    <Drawer anchor='bottom' open={open} onClose={onClose} PaperProps={{ sx: { backgroundColor: COLORS.primary.main } }}>
      <Stack direction={'column'} display={'flex'} justifyContent={'center'} alignItems={'center'} padding={4}>
        <Logo width={120} />

        <Text
          variant='body2'
          fontSize={14}
          color={COLORS.others.white}
          sx={{ textTransform: 'uppercase', fontWeight: 'bold', marginBottom: 1, marginTop: 3 }}
        >
          Acesso rápido à sua coleta
        </Text>

        <Text variant='body1' fontSize={14} color={COLORS.others.white} sx={{ textAlign: 'center' }}>
          Adicione o e-método à sua tela inicial e abra a agenda do dia com um toque.
        </Text>

        <Button
          size='small'
          variant='contained'
          onClick={handleInstall}
          sx={{ color: COLORS.primary.main, backgroundColor: COLORS.others.white, marginY: 3 }}
        >
          Adicionar à tela inicial
        </Button>

        <Divider sx={{ width: '100%', backgroundColor: COLORS.others.grayHard }} />

        <Button
          size='small'
          variant='text'
          onClick={onClose}
          fullWidth
          sx={{ color: COLORS.others.white, marginTop: 3 }}
        >
          Talvez mais tarde
        </Button>
      </Stack>
    </Drawer>
  );
};

export { AndroidInstallDrawer };
